"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderedText = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
require("cornerstone_ui_core/lib/setupTests");
var _enzyme = require("enzyme");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const renderedText = function () {
  let row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let col = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let index = arguments.length > 2 ? arguments[2] : undefined;
  const value = _lodash.default.get(row, col.dataIndex || col.key);
  if (col.render) {
    const comp = col.render(value, row, index);
    if ( /*#__PURE__*/(0, _react.isValidElement)(comp)) {
      try {
        return (0, _enzyme.shallow)(comp).text();
      } catch (e) {
        return value;
      }
    } else return comp;
  }
  return value;
};
exports.renderedText = renderedText;